// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"MobileMenu_menuContainer__7kBni","menuItems":"MobileMenu_menuItems__A7rLO"};